import openPrintDialog from "@insite/client-framework/Common/Utilities/openPrintDialog";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps;

export interface PrintButtonCustomStyles {
    printClickable?: ButtonPresentationProps;
}

export const PrintButtonStyles: PrintButtonCustomStyles = {
    printClickable: {
        css: css``,
    },
};

const styles = PrintButtonStyles;

const printLabel = translate("Print");

const printOrOpenPrintAllModal = () => {
    openPrintDialog();
};

const PrintButtonCustom: React.FC<Props> = () => {
    return (
        <Button {...styles.printClickable} variant="secondary" onClick={printOrOpenPrintAllModal}>
            {printLabel}
        </Button>
    );
};

const widgetModule: WidgetModule = {
    component: PrintButtonCustom,
    definition: {
        displayName: "Print Button Custom",
        group: "Common",
    },
};

export default widgetModule;
